var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://work.weixin.qq.com/ca/cawcde25aa258fb9f9"}},[_vm._v("点击跳转")])])
}]

export { render, staticRenderFns }